import * as React from 'react';
import { useState } from 'react';
import { createRoot } from 'react-dom/client';
import App from './components/App';
import { FluentProvider } from '@fluentui/react-components';
import { signusDarkTheme, signusLightTheme } from './theme';
import {
  AppearanceContext,
  FontSize,
  loadFontSize,
  loadIsDark,
  persistFontSize,
  persistIsDark,
} from './appearance';

/* global document, Office, module, require, HTMLElement */

const title = 'Signus — Legal Clause Analysis';

const ThemedApp: React.FC = () => {
  const [fontSize, setFontSizeState] = useState<FontSize>(() => loadFontSize());
  const [isDark, setIsDarkState] = useState<boolean>(() => loadIsDark());

  const setFontSize = (s: FontSize) => {
    setFontSizeState(s);
    persistFontSize(s);
  };
  const setIsDark = (v: boolean) => {
    setIsDarkState(v);
    persistIsDark(v);
  };
  const toggleDark = () => setIsDark(!isDark);

  return (
    <AppearanceContext.Provider value={{ fontSize, isDark, setFontSize, toggleDark, setIsDark }}>
      <FluentProvider theme={isDark ? signusDarkTheme : signusLightTheme}>
        <App title={title} />
      </FluentProvider>
    </AppearanceContext.Provider>
  );
};

const rootElement: HTMLElement | null = document.getElementById('container');
const root = rootElement ? createRoot(rootElement) : undefined;

Office.onReady(() => {
  root?.render(<ThemedApp />);
});

if ((module as any).hot) {
  (module as any).hot.accept('./components/App', () => {
    root?.render(<ThemedApp />);
  });
}
